import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchBox, editBox, deleteBox, clearBoxErrors } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import Alert from '../components/home/Alert';
import EditBox from '../components/boxes/EditBox'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  box: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
};

class BoxesEditPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewRedirect: false,
      alertOpen: false,
      alertMessage: '',
      edited: false,
      box: {}
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
    this.props.dispatch(fetchBox(this.props.boxId))
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.box !== nextProps.box) this.setState({box: nextProps.box})
    if (nextProps.error) {
      this.setState({
        alertOpen: true,
        edited: false,
        alertMessage: `${nextProps.error.statusCode} ${nextProps.error.error} ${nextProps.error.message}`,
        error: true,
      });
    }
    if (nextProps.box && !nextProps.error && this.state.edited) {
      this.setState({
        alertOpen: true,
        alertMessage: 'Box edited succesfully!',
        error: false,
      });
    }
  }
  deleteBox(data) {
    const boxes = this.props.boxes;
    // boxes.delete = true;
    this.setState({ boxes });
    this.props.dispatch(deleteBox(data));
    browserHistory.push('/boxes');
  }
  saveEditBox(box) {
    this.setState({
      edited: true,
    });
    var new_box = box
    new_box.sequence = Number(new_box.sequence)
    this.props.dispatch(editBox(new_box));
  }
  alertHandleClose() {
    this.setState({
      alertOpen: false,
      edited: false,
      alertMessage: '',
    });
    this.props.dispatch(clearBoxErrors());
    if (!this.state.error) {
      browserHistory.push('/boxes');
    }
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    }
    return (
      <div className="boxes component" style={authPage}>
        <h2>Edit Box</h2>
        <Alert
          alertOpen={this.state.alertOpen}
          alertHandleClose={() => this.alertHandleClose()}
          alertMessage={this.state.alertMessage}
        />
        <div className="content">
          <EditBox
            box={this.state.box}
            onSave={data => this.saveEditBox(data)}
            onDelete={data => this.deleteBox(data)}
          />
        </div>
      </div>
    );
  }
}

BoxesEditPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

BoxesEditPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    box: state.boxes && state.boxes.box && state.boxes.box[0],
    boxId: ownProps.params.id,
    // error: state.boxes.error,
  };
}

export default withRouter(connect(mapStateToProps)(BoxesEditPage));



// WEBPACK FOOTER //
// ./src/containers/BoxesEditPage.js